<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="400"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        x-small
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>
    
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Department History"
      text="Update department record"
      class="mb-0"
      :loading="loading"
    >
      <form v-if="dialog && !loading">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              class="pb-0"
            >
              <v-menu
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="startDateDisplay"
                    outlined
                    readonly
                    label="Start Date"
                    :error-messages="errors.collect('startDateDisplay')"
                    data-vv-name="startDateDisplay"    
                    data-vv-as="start date"
                    :class="{
                      'required':!startDateDisplay
                    }"
                    class="label-department" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localStartDate"
                  :min="minStartDate"
                  :max="localEndDate"
                  @input="startDateMenu = false"
                />
              </v-menu>

              <v-menu
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="endDateDisplay"
                    outlined
                    readonly
                    label="End Date"
                    :error-messages="errors.collect('endDateDisplay')"
                    data-vv-name="endDateDisplay"    
                    data-vv-as="end date"
                    :class="{
                      'required':!endDateDisplay
                    }"
                    class="label-department" 
                    v-on="on"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon>
                        mdi-calendar
                      </v-icon>
                    </template>

                    <template v-slot:append>
                      <v-btn
                        v-if="localEndDate != null && index == 0"
                        class="mb-3"
                        icon
                        @click="clearEndDate"
                      >
                        <v-icon color="red">
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker
                  v-model="localEndDate"
                  :min="localStartDate"
                  :max="maxEndDate"
                  @input="endDateMenu = false"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"    
          class="white--text px-10"      
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions> 
    </material-card>  
  </v-dialog>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      index: {
        type: Number,
        required: true,
      },
      departmentRecord: {
        type: Object,
        required: true,
      },
      minStartDate: {
        type: String,
        default: null,
      },
      maxEndDate: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localDepartmentRecord: null,
        localStartDate: null,
        localEndDate: null,
        loading: false,
        startDateMenu: false,
        endDateMenu: false,
      }
    },
    computed: {
      startDateDisplay () {
        return this.localStartDate ? this.$moment(this.localStartDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
      endDateDisplay () {
        return this.localEndDate ? this.$moment(this.localEndDate, 'YYYY-MM-DD').format('DD-MM-YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.loading = true

        this.localDepartmentRecord = { ...this.departmentRecord }
        this.localStartDate = this.localDepartmentRecord.start_date
        this.localEndDate = this.localDepartmentRecord.end_date

        this.loading = false
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.setProgressing(true)

            this.$api.hrisEmployeeDepartments().update(this.departmentRecord.id, this.prepareFormData())
              .then(response => {
                if (response.status === 200) {
                  this.$emit('updated')
                  this.$snack({ message: 'Employee department record updated' })

                  this.setProgressing(false)
                  this.dialog = false
                }
              })
          })
      },
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          start_date: this.localStartDate,
          end_date: this.localEndDate,
        }
      },
      clearEndDate () {
        this.localEndDate = null
      },
    },
  }
</script>

<style scoped>
.label-department >>> .v-label.v-label--active{
  margin-left:-28px;
  background: white;
}
</style>
